#import "./fields.graphql"

# Full evaluation. Used by the open inbox item and by a deep link that
# is no longer on the caller's queue.
query inboxRequisitionLookup($searchTerms: [String!]!, $size: Int!) {
  result: searchRequisitions(
    searchTerms: $searchTerms
    size: $size
    page: 1
    activeOnly: false
  ) {
    requisitions {
      ...InboxRequisitionFields
    }
  }
}
